












  import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
  import { QuizSessionQuestionPhase } from '@/app/quiz-player/api'
  import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';

  @Component({
    components: {
      UiStatusBarComponent
    }
  })
  export default class QuizStatusBarComponentNew extends Vue {
    @Prop({ required: true })
    public questions: string[];

    @Prop({ required: true })
    public questionsState: QuizSessionQuestionPhase[]
    
    @Prop({ default: -1 })
    public currentIndex: number;

    @Prop({ required: true })
    public lastVisitedIndex: number;

    @Prop({
      default: true
    })
    public showProgress: boolean;

    public get percentage(): number {

      if (!this.showProgress) {
        return 100;
      }

      const total = this.questions.length
      if (total === 1) {
        return 100
      }
      return 100 * this.lastVisitedIndex / (total - 1);
    }

    public get dotsArray(): ItemState[] {

      const result = this.questionsState.map((x, index) => {
        const type = this.getTypeByState(x);
        return {
          type: index === this.currentIndex ? [ 'current', type] : type,
          hint: this.questions[index]
        } as ItemState
      })

      return result
    }

    public handleDotClicked(index: number): void {
      this.emitNavigated(index)
    }

    @Emit('navigated')
    public emitNavigated(index: number): number {
      return index
    }

    private getTypeByState(state: QuizSessionQuestionPhase): DisplayState {
      const found = typeMap.find(x => x[0] === state)
      if (!found) { throw new Error('Coding error: ' + state) }
      return found[1]
    }
  }

const typeMap: [ QuizSessionQuestionPhase, DisplayState][] = [
  [ 'not-attempted', 'unanswered' ],
  [ 'not-evaluated', 'unevaluated'],
  ['correct', 'correct'],
  ['incorrect', 'incorrect'],
  ['partially-correct', 'halfright'],
  [ 'disabled', 'disabled' ]
]

  type DisplayState = 'unanswered' | 'unevaluated' | 'correct' | 'incorrect' | 'disabled' | 'halfright'
    type ItemState = {
      type: DisplayState | [ 'current', DisplayState ]
      hint: string
    }
